"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelsSpecialPricingRuleExpandedStatusEnum = exports.ModelsSpecialPricingRuleExpandedTestPriceTypeEnum = exports.ModelsSpecialPricingRuleExpandedOrderTypeEnum = exports.ModelsSpecialPricingRuleExpandedGroupTypeEnum = void 0;
exports.ModelsSpecialPricingRuleExpandedGroupTypeEnum = {
    Account: 'Account',
    Partnership: 'Partnership'
};
exports.ModelsSpecialPricingRuleExpandedOrderTypeEnum = {
    Diagnostic: 'Diagnostic',
    StatTat: 'STAT-TAT',
    SmaStat: 'SMA-STAT',
    Carrier: 'Carrier',
    Nips: 'NIPS',
    Exome: 'Exome',
    ExomePreventiveAddOn: 'Exome Preventive Add-On',
    Preventive: 'Preventive',
    CombiPoc: 'Combi POC',
    CombiPfu: 'Combi PFU',
    CombiRpl: 'Combi RPL',
    CombiCdd: 'Combi CDD',
    CombiPd: 'Combi PD',
    CombiCc: 'Combi CC'
};
exports.ModelsSpecialPricingRuleExpandedTestPriceTypeEnum = {
    Oncology: 'Oncology',
    NonOncology: 'Non-Oncology',
    FvtVus: 'FVT/VUS',
    ReReq: 'Re-Req',
    PositiveFinding: 'Positive Finding',
    Standard: 'Standard',
    Partner: 'Partner',
    Donor: 'Donor',
    ProbandOnly: 'Proband-Only',
    Duo: 'Duo',
    Trio: 'Trio',
    CancerScreen: 'Cancer Screen',
    CardioScreen: 'Cardio Screen',
    GeneticHealthScreen: 'Genetic Health Screen',
    OtherScreen: 'Other Screen',
    CmaFollowUp: 'CMA Follow-Up',
    FishFollowUp: 'FISH Follow-Up',
    KaryotypeFollowUp: 'Karyotype Follow-Up',
    Cma: 'CMA',
    Fish: 'FISH',
    Karyotype: 'Karyotype',
    FragileX: 'Fragile X',
    Afp: 'AFP',
    AchE: 'AChE',
    Mcc: 'MCC'
};
exports.ModelsSpecialPricingRuleExpandedStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
};
